// extracted by mini-css-extract-plugin
module.exports = {"donwload_container":"downloads_donwload_container__ku4Cb","download_hero":"downloads_download_hero__IUMRD","download_inner":"downloads_download_inner__Omrx7"};